import { FC, useMemo, DetailedHTMLProps, AnchorHTMLAttributes } from 'react';
import NextLink from 'next/link';

export const Link: FC<
  DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = ({ href = '/', ...props }) => {
  const isInnerLink = useMemo(
    () =>
      href?.startsWith('/') ||
      href?.startsWith('#') ||
      (process.env.NEXT_PUBLIC_API_HOST &&
        href?.startsWith(process.env.NEXT_PUBLIC_API_HOST)),
    [href]
  );

  const isSpecialLink = useMemo(() => !href?.startsWith('http'), [href]);

  // Внутренние ссылки, в пределах данного домена
  if (isInnerLink) {
    return (
      <NextLink href={href} {...(props as any)}>
        {props.children}
      </NextLink>
    );
  }

  // Специальные ссылки, которые не используют http (например, mailto)
  if (isSpecialLink) {
    return <a href={href} {...props} />;
  }

  // Внешние ссылки, ведущие на другой домен
  return <a href={href} {...props} rel="noopener noreferrer nofollow" />;
};
